module.exports = __webpack_public_path__ + "static/media/feat-cumberland-img3.cd8b97cd.jpg";